import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { WorkflowReferenceNavigationService } from '@blaze-dashboard/editor-data-access';
import { WorkflowReferencesListComponent } from '@blaze-runtime/engine-feature';
import { ReferenceInfo } from '@blaze-shared/api-contracts-domain';
import { DialogComponent } from '@blaze-shared/shared-ui';

export interface ColumnUseDialogInput {
  references: ReferenceInfo[];
}

@Component({
  selector: 'blaze-column-use-dialog',
  imports: [DialogComponent, MatIconModule, WorkflowReferencesListComponent],
  templateUrl: './column-use-dialog.component.html',
  styleUrls: ['./column-use-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnUseDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<ColumnUseDialogComponent>>(MatDialogRef);
  private readonly navigation = inject(WorkflowReferenceNavigationService);

  protected readonly references = inject<ColumnUseDialogInput>(MAT_DIALOG_DATA).references;

  closeDialog(): void {
    this.dialogRef.close();
  }

  protected openReference(reference: ReferenceInfo): void {
    this.navigation.openReference(reference);
    this.closeDialog();
  }
}
